import React, { useState } from "react";
import { Alert, Button, Input } from "antd";
import { ArrowLeftOutlined, LockOutlined, UserOutlined } from "@ant-design/icons";
import { useMutation } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";
import useUser from "./../../hooks/useUser";
import "./login.css";

const Login = ({ setUser }) => {
  const { LoginRequest } = useUser();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const { mutate: login, isPending } = useMutation({
    mutationFn: LoginRequest,
    onSuccess: (res) => {
      localStorage.setItem("blood-token", res.token);
      setUser(res);
      navigate("/home");
    },
    onError: (err) => {
      // The server says whether the username or the password was wrong;
      // keep that to ourselves.
      setError(err?.response ? "Wrong username or password." : "Could not reach the server. Try again.");
    },
  });

  const submit = (e) => {
    e.preventDefault();
    if (!username.trim() || !password) {
      setError("Enter your username and password.");
      return;
    }
    setError("");
    login({ username: username.trim(), password });
  };

  return (
    <div className="adm-login">
      <form className="adm-login__card" onSubmit={submit}>
        <div className="adm-login__brand">
          <span className="adm-login__mark">0709</span>
          <span className="adm-login__tag">Admin</span>
        </div>
        <h1 className="adm-login__title">Sign in to the dashboard</h1>
        <p className="adm-login__hint">Manage donors, notes, the gallery and suggestions.</p>

        {error ? <Alert type="error" showIcon message={error} className="adm-login__error" /> : null}

        <label className="adm-login__label" htmlFor="admin-username">
          Username
        </label>
        <Input
          id="admin-username"
          size="large"
          prefix={<UserOutlined />}
          autoComplete="username"
          autoFocus
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <label className="adm-login__label" htmlFor="admin-password">
          Password
        </label>
        <Input.Password
          id="admin-password"
          size="large"
          prefix={<LockOutlined />}
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <Button type="primary" htmlType="submit" size="large" block loading={isPending} className="adm-login__submit">
          Sign in
        </Button>

        <Link to="/" className="adm-login__back">
          <ArrowLeftOutlined /> Back to the app
        </Link>
      </form>
    </div>
  );
};

export default Login;
